import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getDate, confirmDeleteFile } from "../../utils";
import { usePostTags } from "../../hooks";
import EditTags from "../wiki/edit-tags";

export function FileIndexItem({ file, setFileList, updateFile }) {
  const {
    updateTagsForFile,
    deleteTagFromFile,
    updateFile: updateFileOnServer,
    tagIdMap,
  } = usePostTags({
    initialize: false,
  });
  return (
    <div className="post-item" key={file.uuid}>
      <span className="post-item__details">
        <div className="post-item__details__left-details">
          <span>
            <a
              className="post-item__details__link"
              href={`/api/s3/?id=${file.uuid}`}
              target="_blank"
              download
            >
              <strong className="color-black">{file.fileName}</strong>
            </a>
          </span>
          {" | "}
          <span
            onClick={async () => {
              const nextName = window.prompt(
                "What would you like to name the file?"
              );
              if (nextName) {
                const { body } = await updateFileOnServer({
                  file: { ...file, fileName: nextName },
                });
                updateFile(body);
              }
            }}
            className="link-button"
          >
            Rename
          </span>
          <>
            <br />
            <br />
            <EditTags
              tags={file.tags.map((t) => (tagIdMap[t] || {}).name)}
              showDelete={true}
              //showAdd={true}
              //TODO add add
              showAdd={true}
              addTag={async ({ nextTag }) => {
                const { body } = await updateTagsForFile({
                  nextTag,
                  file,
                });
                updateFile(body);
              }}
              deleteTag={async (tagName) => {
                const { body } = await deleteTagFromFile({
                  tagName,
                  file,
                });
                updateFile(body);
              }}
            />
          </>
        </div>
        <div style={{ textAlign: "right" }}>
          <span className="post-item__date">{getDate(file.date)}</span>
          <br />
          <button
            className="link-button link-button--delete pr-0"
            onClick={async () => {
              const { body } = await confirmDeleteFile(file.uuid);
              console.log("body");
              console.log(body);
              if (body) {
                setFileList(body.files);
              }
            }}
          >
            Delete
          </button>
        </div>
      </span>
      <hr />
    </div>
  );
}

export default function FileIndexList({ setFileList, fileList }) {
  const [list, setList] = useState([]);
  const updateFile = (updatedFile) => {
    setFileList(
      fileList.map((f) => {
        return f.uuid === updatedFile.uuid ? updatedFile : f;
      })
    );
  };
  useEffect(() => {
    if (!fileList) {
      setList([]);
    } else {
      setList(fileList.sort((a, b) => a.path > b.path));
    }
  }, [fileList]);

  return list.map((item) => (
    <FileIndexItem
      updateFile={updateFile}
      key={item.uuid}
      setFileList={setFileList}
      file={item}
    />
  ));
}
